import OriginTracer from '@atlassiansox/origin-tracing/origin-tracer';

const orgIdAttribute = 'pls_org_id';

type TracedContactSalesLink = {
	url: string;
	metadata: Record<string, string | number | boolean | null>;
};

export const getTracedContactSalesLink = (
	contactSalesUrl: string,
	orgId: string | undefined,
	enabled: boolean,
): TracedContactSalesLink => {
	const fallback = { url: contactSalesUrl, metadata: {} };
	if (!enabled || !orgId || !/^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/i.test(orgId)) {
		return fallback;
	}

	try {
		const identityUrl = new URL(contactSalesUrl);
		const continueUrl = identityUrl.searchParams.get('continue');
		if (
			identityUrl.protocol !== 'https:' ||
			!['id.atlassian.com', 'id.stg.internal.atlassian.com'].includes(identityUrl.host) ||
			identityUrl.pathname !== '/login' ||
			identityUrl.searchParams.getAll('continue').length !== 1 ||
			!continueUrl
		) {
			return fallback;
		}

		const destination = new URL(continueUrl);
		if (
			destination.protocol !== 'https:' ||
			!['www.atlassian.com', 'wac.stg.internal.atlassian.com'].includes(destination.host) ||
			destination.pathname !== '/enterprise/contact' ||
			destination.searchParams.getAll('pls_source').length !== 1 ||
			destination.searchParams.get('pls_source') !== 'adminhub-billing-preview'
		) {
			return fallback;
		}

		const trace = new OriginTracer({ product: 'admin' });
		destination.searchParams.set('pls_org_id', orgId);
		// The destination must carry context before Identity redirects or the link opens in a new tab.
		identityUrl.searchParams.set('continue', trace.addToUrl(destination.toString()));
		return {
			url: identityUrl.toString(),
			metadata: { [orgIdAttribute]: orgId, ...trace.toAnalyticsAttributes() },
		};
	} catch {
		return fallback;
	}
};
